import { render, staticRenderFns } from "./AdminSessionMaterialChanges.vue?vue&type=template&id=4c364d84"
import script from "./AdminSessionMaterialChanges.vue?vue&type=script&lang=js"
export * from "./AdminSessionMaterialChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports